// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/automations/v1/automations_executions.proto" (package "c1.api.automations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TriggerType } from "./automations";
import { AutomationStep } from "./automations";
import { ScheduleTriggerAppUser } from "./automations";
import { FormTrigger } from "./automations";
import { ScheduleTrigger } from "./automations";
import { GrantDeletedTrigger } from "./automations";
import { GrantFoundTrigger } from "./automations";
import { UserCreatedTrigger } from "./automations";
import { UsageBasedRevocationTrigger } from "./automations";
import { AppUserUpdatedTrigger } from "./automations";
import { AppUserCreatedTrigger } from "./automations";
import { UserProfileChangeTrigger } from "./automations";
import { ManualAutomationTrigger } from "./automations";
import { Duration } from "../../../../google/protobuf/duration";
import { AutomationContext } from "./automations";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.automations.v1.TerminateAutomationRequest
 */
export interface TerminateAutomationRequest {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.TerminateAutomationResponse
 */
export interface TerminateAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionsRequest
 */
export interface ListAutomationExecutionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionsResponse
 */
export interface ListAutomationExecutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecution automation_executions = 1;
     */
    automationExecutions: AutomationExecution[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionRequest
 */
export interface GetAutomationExecutionRequest {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 2;
     */
    expandMask?: AutomationExecutionExpandMask;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionResponse
 */
export interface GetAutomationExecutionResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecution automation_execution = 1;
     */
    automationExecution?: AutomationExecution;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionView view = 3;
     */
    view?: AutomationExecutionView;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecution
 */
export interface AutomationExecution {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: number;
    /**
     * @generated from protobuf field: string automation_template_id = 2;
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionState state = 6;
     */
    state: AutomationExecutionState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 7;
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 8;
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 9;
     */
    duration?: Duration;
    /**
     * @generated from protobuf field: int32 current_version = 10;
     */
    currentVersion: number;
    /**
     * @generated from protobuf field: bool is_draft = 11;
     */
    isDraft: boolean;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionExpandMask
 */
export interface AutomationExecutionExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionView
 */
export interface AutomationExecutionView {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecution automation_execution = 1;
     */
    automationExecution?: AutomationExecution;
    /**
     * @generated from protobuf field: string automation_path = 2;
     */
    automationPath: string;
    /**
     * @generated from protobuf field: string automation_execution_trigger_path = 3;
     */
    automationExecutionTriggerPath: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionsResponse
 */
export interface SearchAutomationExecutionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionView list = 1;
     */
    list: AutomationExecutionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionsRequest
 */
export interface SearchAutomationExecutionsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string automation_template_id = 3;
     */
    automationTemplateId: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionExpandMask expand_mask = 5;
     */
    expandMask?: AutomationExecutionExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionRef refs = 6;
     */
    refs: AutomationExecutionRef[];
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionState execution_step_states = 7;
     */
    executionStepStates: AutomationExecutionState[];
    /**
     * @generated from protobuf field: int64 execution_id = 8;
     */
    executionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionTrigger
 */
export interface AutomationExecutionTrigger {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string actor_id = 2;
     */
    actorId: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "manual";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ManualAutomationTrigger manual = 101;
         */
        manual: ManualAutomationTrigger;
    } | {
        oneofKind: "userProfileChange";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserProfileChangeTrigger user_profile_change = 102;
         */
        userProfileChange: UserProfileChangeTrigger;
    } | {
        oneofKind: "appUserCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserCreatedTrigger app_user_created = 103;
         */
        appUserCreated: AppUserCreatedTrigger;
    } | {
        oneofKind: "appUserUpdated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AppUserUpdatedTrigger app_user_updated = 104;
         */
        appUserUpdated: AppUserUpdatedTrigger;
    } | {
        oneofKind: "usageBasedRevocation";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UsageBasedRevocationTrigger usage_based_revocation = 105;
         */
        usageBasedRevocation: UsageBasedRevocationTrigger;
    } | {
        oneofKind: "userCreated";
        /**
         * @generated from protobuf field: c1.api.automations.v1.UserCreatedTrigger user_created = 106;
         */
        userCreated: UserCreatedTrigger;
    } | {
        oneofKind: "grantFound";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantFoundTrigger grant_found = 107;
         */
        grantFound: GrantFoundTrigger;
    } | {
        oneofKind: "grantDeleted";
        /**
         * @generated from protobuf field: c1.api.automations.v1.GrantDeletedTrigger grant_deleted = 108;
         */
        grantDeleted: GrantDeletedTrigger;
    } | {
        oneofKind: "schedule";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTrigger schedule = 109;
         */
        schedule: ScheduleTrigger;
    } | {
        oneofKind: "form";
        /**
         * @generated from protobuf field: c1.api.automations.v1.FormTrigger form = 110;
         */
        form: FormTrigger;
    } | {
        oneofKind: "scheduleAppUser";
        /**
         * @generated from protobuf field: c1.api.automations.v1.ScheduleTriggerAppUser schedule_app_user = 111;
         */
        scheduleAppUser: ScheduleTriggerAppUser;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStep
 */
export interface AutomationExecutionStep {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepState state = 3;
     */
    state: AutomationExecutionStepState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationStep automation_step = 4;
     */
    automationStep?: AutomationStep;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext context = 5;
     */
    context?: AutomationContext;
    /**
     * @generated from protobuf field: string error_message = 6;
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutput output = 7;
     */
    output?: AutomationExecutionStepOutput;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutput
 */
export interface AutomationExecutionStepOutput {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string automation_execution_step_id = 2;
     */
    automationExecutionStepId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutputSuccess success = 101;
         */
        success: AutomationExecutionStepOutputSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutputError error = 102;
         */
        error: AutomationExecutionStepOutputError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutputSuccess
 */
export interface AutomationExecutionStepOutputSuccess {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationContext exported_context = 1;
     */
    exportedContext?: AutomationContext;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepOutputError
 */
export interface AutomationExecutionStepOutputError {
    /**
     * @generated from protobuf field: string error = 1;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.CompletedAutomationExecutionStep
 */
export interface CompletedAutomationExecutionStep {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepState state = 3;
     */
    state: AutomationExecutionStepState;
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStep step = 4;
     */
    step?: AutomationExecutionStep;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest
 */
export interface GetCompletedAutomationExecutionStepRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse
 */
export interface GetCompletedAutomationExecutionStepResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.CompletedAutomationExecutionStep completed_automation_execution_steps = 1;
     */
    completedAutomationExecutionSteps: CompletedAutomationExecutionStep[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionStepsRequest
 */
export interface ListAutomationExecutionStepsRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.ListAutomationExecutionStepsResponse
 */
export interface ListAutomationExecutionStepsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStep automation_execution_steps = 1;
     */
    automationExecutionSteps: AutomationExecutionStep[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsRequest
 */
export interface SearchAutomationExecutionStepsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: int64 automation_execution_id = 3;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStepRef refs = 5;
     */
    refs: AutomationExecutionStepRef[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsResponse
 */
export interface SearchAutomationExecutionStepsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.AutomationExecutionStep list = 1;
     */
    list: AutomationExecutionStep[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputRequest
 */
export interface GetAutomationExecutionStepOutputRequest {
    /**
     * @generated from protobuf field: int64 automation_execution_id = 1;
     */
    automationExecutionId: number;
    /**
     * @generated from protobuf field: string step_id = 2;
     */
    stepId: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputResponse
 */
export interface GetAutomationExecutionStepOutputResponse {
    /**
     * @generated from protobuf field: c1.api.automations.v1.AutomationExecutionStepOutput output = 1;
     */
    output?: AutomationExecutionStepOutput;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionRef
 */
export interface AutomationExecutionRef {
    /**
     * @generated from protobuf field: int64 id = 1;
     */
    id: number;
}
/**
 * @generated from protobuf message c1.api.automations.v1.AutomationExecutionStepRef
 */
export interface AutomationExecutionStepRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest
 */
export interface SearchAutomationExecutionCountForAppRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.automations.v1.TriggerType trigger_types = 2;
     */
    triggerTypes: TriggerType[];
}
/**
 * @generated from protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse
 */
export interface SearchAutomationExecutionCountForAppResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf enum c1.api.automations.v1.AutomationExecutionState
 */
export enum AutomationExecutionState {
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_CREATING = 2;
     */
    CREATING = 2,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_GET_STEP = 3;
     */
    GET_STEP = 3,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_PROCESS_STEP = 4;
     */
    PROCESS_STEP = 4,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_COMPLETE_STEP = 5;
     */
    COMPLETE_STEP = 5,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_DONE = 6;
     */
    DONE = 6,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_ERROR = 7;
     */
    ERROR = 7,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_TERMINATE = 8;
     */
    TERMINATE = 8,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STATE_WAITING = 9;
     */
    WAITING = 9
}
/**
 * @generated from protobuf enum c1.api.automations.v1.AutomationExecutionStepState
 */
export enum AutomationExecutionStepState {
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_RUNNING = 2;
     */
    RUNNING = 2,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_ERROR = 4;
     */
    ERROR = 4,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_CANCELLED = 5;
     */
    CANCELLED = 5,
    /**
     * @generated from protobuf enum value: AUTOMATION_EXECUTION_STEP_STATE_SKIPPED = 6;
     */
    SKIPPED = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class TerminateAutomationRequest$Type extends MessageType<TerminateAutomationRequest> {
    constructor() {
        super("c1.api.automations.v1.TerminateAutomationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TerminateAutomationRequest
 */
export const TerminateAutomationRequest = new TerminateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TerminateAutomationResponse$Type extends MessageType<TerminateAutomationResponse> {
    constructor() {
        super("c1.api.automations.v1.TerminateAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.TerminateAutomationResponse
 */
export const TerminateAutomationResponse = new TerminateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionsRequest$Type extends MessageType<ListAutomationExecutionsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionsRequest
 */
export const ListAutomationExecutionsRequest = new ListAutomationExecutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionsResponse$Type extends MessageType<ListAutomationExecutionsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionsResponse", [
            { no: 1, name: "automation_executions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecution },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionsResponse
 */
export const ListAutomationExecutionsResponse = new ListAutomationExecutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionRequest$Type extends MessageType<GetAutomationExecutionRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "expand_mask", kind: "message", T: () => AutomationExecutionExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionRequest
 */
export const GetAutomationExecutionRequest = new GetAutomationExecutionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionResponse$Type extends MessageType<GetAutomationExecutionResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionResponse", [
            { no: 1, name: "automation_execution", kind: "message", T: () => AutomationExecution },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "view", kind: "message", T: () => AutomationExecutionView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionResponse
 */
export const GetAutomationExecutionResponse = new GetAutomationExecutionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecution$Type extends MessageType<AutomationExecution> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecution", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionState", AutomationExecutionState, "AUTOMATION_EXECUTION_STATE_"] },
            { no: 7, name: "context", kind: "message", T: () => AutomationContext },
            { no: 8, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "duration", kind: "message", T: () => Duration },
            { no: 10, name: "current_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "is_draft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecution
 */
export const AutomationExecution = new AutomationExecution$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionExpandMask$Type extends MessageType<AutomationExecutionExpandMask> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "automation_id", "automation_trigger_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionExpandMask
 */
export const AutomationExecutionExpandMask = new AutomationExecutionExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionView$Type extends MessageType<AutomationExecutionView> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionView", [
            { no: 1, name: "automation_execution", kind: "message", T: () => AutomationExecution },
            { no: 2, name: "automation_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "automation_execution_trigger_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionView
 */
export const AutomationExecutionView = new AutomationExecutionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionsResponse$Type extends MessageType<SearchAutomationExecutionsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionsResponse
 */
export const SearchAutomationExecutionsResponse = new SearchAutomationExecutionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionsRequest$Type extends MessageType<SearchAutomationExecutionsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expand_mask", kind: "message", T: () => AutomationExecutionExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionRef },
            { no: 7, name: "execution_step_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.AutomationExecutionState", AutomationExecutionState, "AUTOMATION_EXECUTION_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionsRequest
 */
export const SearchAutomationExecutionsRequest = new SearchAutomationExecutionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionTrigger$Type extends MessageType<AutomationExecutionTrigger> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionTrigger", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "manual", kind: "message", oneof: "kind", T: () => ManualAutomationTrigger },
            { no: 102, name: "user_profile_change", kind: "message", oneof: "kind", T: () => UserProfileChangeTrigger },
            { no: 103, name: "app_user_created", kind: "message", oneof: "kind", T: () => AppUserCreatedTrigger },
            { no: 104, name: "app_user_updated", kind: "message", oneof: "kind", T: () => AppUserUpdatedTrigger },
            { no: 105, name: "usage_based_revocation", kind: "message", oneof: "kind", T: () => UsageBasedRevocationTrigger },
            { no: 106, name: "user_created", kind: "message", oneof: "kind", T: () => UserCreatedTrigger },
            { no: 107, name: "grant_found", kind: "message", oneof: "kind", T: () => GrantFoundTrigger },
            { no: 108, name: "grant_deleted", kind: "message", oneof: "kind", T: () => GrantDeletedTrigger },
            { no: 109, name: "schedule", kind: "message", oneof: "kind", T: () => ScheduleTrigger },
            { no: 110, name: "form", kind: "message", oneof: "kind", T: () => FormTrigger },
            { no: 111, name: "schedule_app_user", kind: "message", oneof: "kind", T: () => ScheduleTriggerAppUser }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionTrigger
 */
export const AutomationExecutionTrigger = new AutomationExecutionTrigger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStep$Type extends MessageType<AutomationExecutionStep> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStep", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionStepState", AutomationExecutionStepState, "AUTOMATION_EXECUTION_STEP_STATE_"] },
            { no: 4, name: "automation_step", kind: "message", T: () => AutomationStep },
            { no: 5, name: "context", kind: "message", T: () => AutomationContext },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "output", kind: "message", T: () => AutomationExecutionStepOutput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStep
 */
export const AutomationExecutionStep = new AutomationExecutionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutput$Type extends MessageType<AutomationExecutionStepOutput> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutput", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "automation_execution_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "success", kind: "message", oneof: "kind", T: () => AutomationExecutionStepOutputSuccess },
            { no: 102, name: "error", kind: "message", oneof: "kind", T: () => AutomationExecutionStepOutputError }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutput
 */
export const AutomationExecutionStepOutput = new AutomationExecutionStepOutput$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutputSuccess$Type extends MessageType<AutomationExecutionStepOutputSuccess> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutputSuccess", [
            { no: 1, name: "exported_context", kind: "message", T: () => AutomationContext }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutputSuccess
 */
export const AutomationExecutionStepOutputSuccess = new AutomationExecutionStepOutputSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepOutputError$Type extends MessageType<AutomationExecutionStepOutputError> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepOutputError", [
            { no: 1, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepOutputError
 */
export const AutomationExecutionStepOutputError = new AutomationExecutionStepOutputError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompletedAutomationExecutionStep$Type extends MessageType<CompletedAutomationExecutionStep> {
    constructor() {
        super("c1.api.automations.v1.CompletedAutomationExecutionStep", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["c1.api.automations.v1.AutomationExecutionStepState", AutomationExecutionStepState, "AUTOMATION_EXECUTION_STEP_STATE_"] },
            { no: 4, name: "step", kind: "message", T: () => AutomationExecutionStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.CompletedAutomationExecutionStep
 */
export const CompletedAutomationExecutionStep = new CompletedAutomationExecutionStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompletedAutomationExecutionStepRequest$Type extends MessageType<GetCompletedAutomationExecutionStepRequest> {
    constructor() {
        super("c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepRequest
 */
export const GetCompletedAutomationExecutionStepRequest = new GetCompletedAutomationExecutionStepRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCompletedAutomationExecutionStepResponse$Type extends MessageType<GetCompletedAutomationExecutionStepResponse> {
    constructor() {
        super("c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse", [
            { no: 1, name: "completed_automation_execution_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CompletedAutomationExecutionStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetCompletedAutomationExecutionStepResponse
 */
export const GetCompletedAutomationExecutionStepResponse = new GetCompletedAutomationExecutionStepResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionStepsRequest$Type extends MessageType<ListAutomationExecutionStepsRequest> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionStepsRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionStepsRequest
 */
export const ListAutomationExecutionStepsRequest = new ListAutomationExecutionStepsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExecutionStepsResponse$Type extends MessageType<ListAutomationExecutionStepsResponse> {
    constructor() {
        super("c1.api.automations.v1.ListAutomationExecutionStepsResponse", [
            { no: 1, name: "automation_execution_steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStep }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.ListAutomationExecutionStepsResponse
 */
export const ListAutomationExecutionStepsResponse = new ListAutomationExecutionStepsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionStepsRequest$Type extends MessageType<SearchAutomationExecutionStepsRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionStepsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStepRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsRequest
 */
export const SearchAutomationExecutionStepsRequest = new SearchAutomationExecutionStepsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionStepsResponse$Type extends MessageType<SearchAutomationExecutionStepsResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionStepsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationExecutionStep },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionStepsResponse
 */
export const SearchAutomationExecutionStepsResponse = new SearchAutomationExecutionStepsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionStepOutputRequest$Type extends MessageType<GetAutomationExecutionStepOutputRequest> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionStepOutputRequest", [
            { no: 1, name: "automation_execution_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gt: "0" } } } },
            { no: 2, name: "step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputRequest
 */
export const GetAutomationExecutionStepOutputRequest = new GetAutomationExecutionStepOutputRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAutomationExecutionStepOutputResponse$Type extends MessageType<GetAutomationExecutionStepOutputResponse> {
    constructor() {
        super("c1.api.automations.v1.GetAutomationExecutionStepOutputResponse", [
            { no: 1, name: "output", kind: "message", T: () => AutomationExecutionStepOutput }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.GetAutomationExecutionStepOutputResponse
 */
export const GetAutomationExecutionStepOutputResponse = new GetAutomationExecutionStepOutputResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionRef$Type extends MessageType<AutomationExecutionRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionRef", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { gte: "0" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionRef
 */
export const AutomationExecutionRef = new AutomationExecutionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationExecutionStepRef$Type extends MessageType<AutomationExecutionStepRef> {
    constructor() {
        super("c1.api.automations.v1.AutomationExecutionStepRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.AutomationExecutionStepRef
 */
export const AutomationExecutionStepRef = new AutomationExecutionStepRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionCountForAppRequest$Type extends MessageType<SearchAutomationExecutionCountForAppRequest> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "trigger_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.automations.v1.TriggerType", TriggerType, "TRIGGER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppRequest
 */
export const SearchAutomationExecutionCountForAppRequest = new SearchAutomationExecutionCountForAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAutomationExecutionCountForAppResponse$Type extends MessageType<SearchAutomationExecutionCountForAppResponse> {
    constructor() {
        super("c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.automations.v1.SearchAutomationExecutionCountForAppResponse
 */
export const SearchAutomationExecutionCountForAppResponse = new SearchAutomationExecutionCountForAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionSearchService
 */
export const AutomationExecutionSearchService = new ServiceType("c1.api.automations.v1.AutomationExecutionSearchService", [
    { name: "SearchAutomationExecutions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automation_executions/search", group: "Automations" }] } }, I: SearchAutomationExecutionsRequest, O: SearchAutomationExecutionsResponse },
    { name: "SearchAutomationExecutionCountForApp", options: { "authz.method": { role: "VIEWER" } }, I: SearchAutomationExecutionCountForAppRequest, O: SearchAutomationExecutionCountForAppResponse },
    { name: "SearchAutomationExecutionSteps", options: { "authz.method": { role: "VIEWER" } }, I: SearchAutomationExecutionStepsRequest, O: SearchAutomationExecutionStepsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionService
 */
export const AutomationExecutionService = new ServiceType("c1.api.automations.v1.AutomationExecutionService", [
    { name: "GetAutomationExecution", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automation_executions/{id}", group: "Automations" }] } }, I: GetAutomationExecutionRequest, O: GetAutomationExecutionResponse },
    { name: "ListAutomationExecutions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/automation_executions", group: "Automations" }] } }, I: ListAutomationExecutionsRequest, O: ListAutomationExecutionsResponse },
    { name: "ListAutomationExecutionSteps", options: { "authz.method": { role: "VIEWER" } }, I: ListAutomationExecutionStepsRequest, O: ListAutomationExecutionStepsResponse },
    { name: "GetAutomationExecutionStepOutput", options: { "authz.method": { role: "VIEWER" } }, I: GetAutomationExecutionStepOutputRequest, O: GetAutomationExecutionStepOutputResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.automations.v1.AutomationExecutionActionsService
 */
export const AutomationExecutionActionsService = new ServiceType("c1.api.automations.v1.AutomationExecutionActionsService", [
    { name: "TerminateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/automation_executions/{id}/actions/terminate", group: "Automations" }] } }, I: TerminateAutomationRequest, O: TerminateAutomationResponse }
]);
